(() => {
  'use strict';

  const init = (root) => {
    if (!root || root.dataset.alePdpReady === 'true') return;
    root.dataset.alePdpReady = 'true';

    const dataNode = root.querySelector('[data-ale-pdp-variants]');
    let variants = {};
    try {
      variants = JSON.parse(dataNode?.textContent || '{}');
    } catch (error) {
      console.warn('[ALE PDP] Variant data could not be parsed.', error);
    }

    const update = (variantId) => {
      const data = variants[String(variantId || '')];
      if (!data) return;

      const colorMoment = root.querySelector('[data-ale-pdp-color-moment]');
      if (colorMoment && data.colorHex) {
        colorMoment.style.setProperty('--ale-selected-color', data.colorHex);
      }

      const colorQuatrefoil = root.querySelector('[data-ale-pdp-color-quatrefoil]');
      if (colorQuatrefoil && data.quatrefoilImage) colorQuatrefoil.src = data.quatrefoilImage;

      root.querySelectorAll('[data-ale-pdp-color-name]').forEach((el) => { el.textContent = data.colorName || ''; });
      root.querySelectorAll('[data-ale-pdp-color-name-inline]').forEach((el) => { el.textContent = data.colorName || ''; });
      root.querySelectorAll('[data-ale-pdp-color-name-cta]').forEach((el) => { el.textContent = data.colorName || ''; });

      const profileLink = root.querySelector('[data-ale-pdp-color-profile-link]');
      if (profileLink && (data.colorHandle || data.colorId)) {
        profileLink.setAttribute('href', `/pages/colors?color=${encodeURIComponent(data.colorHandle || data.colorId)}`);
      }

      root.querySelectorAll('[data-ale-pdp-edge]').forEach((el) => { el.textContent = data.edge || 'Considered'; });
    };

    root.addEventListener('variant:update', (event) => {
      const productId = String(event.detail?.data?.productId || '');
      if (productId && productId !== String(root.dataset.productId || '')) return;
      update(event.detail?.resource?.id);
    });

    document.addEventListener('variant:update', (event) => {
      const productId = String(event.detail?.data?.productId || '');
      if (productId && productId !== String(root.dataset.productId || '')) return;
      update(event.detail?.resource?.id);
    });
  };

  const boot = () => document.querySelectorAll('[data-ale-pdp-story]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
